import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth.service'

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  public link: string = '';
  public showFilter: boolean = false;
  public fengIntegration: boolean = false;
  public hideHeaderFooter: boolean = false;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    //this.addChat()
    if (environment.fengIntegration == true) {
      this.fengIntegration = true
    }

    if (environment.hideHeaderFooter == true) {
      this.hideHeaderFooter = true
    }

    if (this.authService.getCustomer() != null && this.authService.getCustomer()['fengIntegration'] !=null && this.authService.getCustomer()['fengIntegration'] == true) {
      this.fengIntegration = true;
    }

  }

  // addChat() {
  //   let dynamicScript = document.createElement("script");
  //   dynamicScript.setAttribute('id', 'ze-snippet')
  //   dynamicScript.setAttribute('src', "https://static.zdassets.com/ekr/snippet.js?key=b090e806-d665-43d6-b28c-94c793e1bc1c")
  //   document.head.appendChild(dynamicScript);
  // }


}
